import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "selected"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTRow = styled.tr.withConfig({
  displayName: "TableRow__StyledTRow",
  componentId: "mbphkr-0"
})(({
  theme,
  $selected,
  $cssStyles
}) => {
  return Object.assign({
    transition: `background-color 150ms ease-out`,
    '&:hover': {
      backgroundColor: theme.color['temp-future-fill-field-hover']
    }
  }, $selected && {
    '&, &:hover': {
      backgroundColor: theme.color['temp-future-fill-field-pressed']
    }
  }, $cssStyles);
});
export const TableRow = _ref => {
  let {
      children,
      selected
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    callbackProps,
    tokenProps,
    restProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledTRow, Object.assign({}, domProps, callbackProps, restProps, {
    $selected: selected,
    $cssStyles: cssStyles,
    children: children
  }));
};